<template>
    <div class="receiptUpload" v-loading="loading">
        <!-- 已上传过图片 -->
        <template v-if="imgList.length > 0">
            <div style="margin-bottom: 8px">
                <span style="margin-right: 5px">
                    {{ currentData.updateUserName }}
                </span>
                在
                <span style="margin: 0 10px">
                    {{ currentData.updateTime }}
                </span>上传
            </div>
            <div class="fileName-text">
                {{ currentData.name }}
            </div>
            <div style="height: 180px">
                <ul id="goodsViewers" style="display: none">
                    <li v-for="(item, index) in srcList" :key="index">
                        <img :src="item" />
                    </li>
                </ul>
            </div>
            <div class="currentImgIndex">{{ carouselIndex + 1 + ' / ' + imgList.length }}</div>
            <div class="uploader-sign">
                <performance-common-upload
                    ref="goodsCommonUpload"
                    :type="'icon'"
                    :icon="'el-icon-plus pictures'"
                    :showFileList="false"
                    :accept="'.jpg,.jpeg,.png'"
                    :drag="true"
                    :multiple="true"
                    :disabled="loading"
                    :compressImage="true"
                    :maxSize="2"
                    @beforeUpload="beforeUpload"
                    @callback="uploadResponse"
                ></performance-common-upload>
                <el-button
                    type="text"
                    icon="el-icon-delete"
                    @click="handleDeleteImage"
                    :loading="delLoading"
                ></el-button>
                <el-button type="text" icon="el-icon-download" @click="handleDownload"></el-button>
                <input class="input-upload-paste" :disabled="loading" placeholder="截图后，在此处粘贴（Ctrl+V）上传图片" v-on:paste="handlePaste" />
            </div>
        </template>
        <!-- 没上传图片时 -->
        <template v-else>
            <div class="noUpload-sign">
                <performance-common-upload
                    ref="goodsCommonUpload"
                    :type="'icon'"
                    :icon="'el-icon-plus notImg'"
                    :showFileList="false"
                    :accept="'.jpg,.jpeg,.png'"
                    :drag="true"
                    :multiple="true"
                    :compressImage="true"
                    :maxSize="2"
                    @beforeUpload="beforeUpload"
                    @callback="uploadResponse"
                ></performance-common-upload>
                <div class="drag-tip">将图片拖至“加号”上传，或点击上传</div>
                <input class="input-upload-paste" :disabled="loading" placeholder="截图后，在此处粘贴（Ctrl+V）上传图片" v-on:paste="handlePaste" />
            </div>
        </template>
    </div>
</template>
<script>
import Viewer from 'viewerjs';
import 'viewerjs/dist/viewer.css';
import { mapState } from 'vuex';
import _ from 'lodash';
import { ossUpload } from '@/components/lots/OSS/api.js';
import PerformanceCommonUpload from './PerformanceCommonUpload.vue';
import { deletePicture } from '@/modules/transport/otp/api/performanceReceiptSign.js';
import { attachmentEntity } from '../entity.js';
import { imageMinimize } from './imageMinimize.js';
import { filterObjectsByProperty } from './signInDialog/util.js';
export default {
    name: 'goodsFrontUpload',
    props: {
        attachmentList: {
            type: Array,
            required: true,
            default () {
                return [];
            }
        },
        rowData: {
            type: Object,
            default () {
                return {};
            }
        }
    },
    components: {
        PerformanceCommonUpload
    },
    data () {
        return {
            carouselIndex: 0, // 当前图片索引
            loading: false,
            delLoading: false,
            picType: '2',
            updateUserName: '', // 当前图片更新人
            updateTime: '', // 当前图片更新时间
            srcList: [], // 当前图片列表
            currentData: {}, // 当前显示图片数据
            viewer: {},
            imgList: []
        };
    },
    computed: {
        ...mapState({ user: state => state.user })
    },
    methods: {
        /**
         * @description 上传附件之前
         */
        beforeUpload () {
            this.loading = true;
        },
        /**
         * @description 图片上传成功回调
         * @param {Object} response oss回调数据
         */
        uploadResponse (response) {
            this.loading = true;
            attachmentEntity.upload(this, response)
                .then(() => {
                    this.$emit('upload-success');
                    this.$refs.goodsCommonUpload.uploadList = [];
                    this.$refs.goodsCommonUpload.uploadFileList = [];
                })
                .catch((error) => {
                    this.$message.error(error);
                })
                .finally(() => { this.loading = false; });
        },

        /**
         * @description 删除图片
         */
        handleDeleteImage () {
            if (this.attachmentList.length === 0) {
                return this.$message.warning('暂无附件上传');
            }
            this.delLoading = true;
            this.loading = true;
            const param = {
                taskNo: this.rowData.taskNo,
                filePath: this.currentData.path
            };
            if (!param.filePath) {
                this.$emit('delete-success');
                return this.$message.success('删除成功');
            };
            deletePicture(param)
                .then(res => {
                    if (res && +res.code === 0) {
                        this.$message.success('删除成功');
                    }
                })
                .catch(() => {
                    this.$message.error('删除失败');
                })
                .finally(() => {
                    this.$emit('delete-success');
                    this.delLoading = false;
                    this.loading = false;
                });
        },

        // 下载图片
        handleDownload () {
            window.location = this.currentData.path;
        },
        handlePaste (event) {
            const items = (event.clipboardData || window.clipboardData).items;
            let file = null;
            if (!items || items.length === 0) {
                this.$message.warning('当前浏览器不支持粘贴图片，请使用点击上传');
                return;
            }
            for (let i = 0; i < items.length; i++) {
                file = items[i].getAsFile();
                break;
            }
            if (!file) {
                this.$message.warning('粘贴内容为非图片，请重新截图');
                return;
            }
            this.submitUpload(file);
        },
        async imageFileProcess (file) {
            const extensionTest = file.name.substring(file.name.lastIndexOf('.') + 1);
            if (extensionTest !== 'jpeg' && extensionTest !== 'jpg' && extensionTest !== 'png' && extensionTest !== 'gif') {
                return file;
            }
            const minimize = await imageMinimize(file, this.compressQuality, this.maxSize);
            return minimize;
        },
        /**
         * @description 上传
         * @param {Object} uploadData 上传后的数据
         */
        async submitUpload (uploadData) {
            this.loading = true;
            const theFile = await this.imageFileProcess(uploadData);
            const file = new File([theFile], uploadData.name, {
                type: uploadData.type
            });
            const formData = new FormData();
            formData.append('file', file);
            formData.append('bucket', 'c-tms');
            formData.append('businessKey', 'default');
            formData.append('publicRead', 1);
            formData.append('contentType', 'application/octet-stream');
            ossUpload(formData).then((res) => {
                if (res && +res.code === 0) {
                    const response = this.callbackFileInfo(res.data.downUrl, uploadData);
                    attachmentEntity.upload(this, [response])
                        .then(() => {
                            // this.$message.success('上传成功');
                            this.$emit('upload-success');
                        })
                        .catch((error) => {
                            this.$message.error(error);
                        })
                        .finally(() => { this.loading = false; });
                }
            }).catch(() => {
                this.loading = false;
            });
        },
        /**
         * @description 处理上传成功回调参数
         * @param {String} url oss响应的url
         * @param {Object} file 文件对象
         */
        callbackFileInfo (url, file) {
            return {
                fileUrl: url,
                fileSize: file.size,
                fileName: file.name
            };
        },
        /**
         * @description 切换图片时，更新图片上传信息
         * @param {Number} index 当前显示图片索引
         */
        updateInfo (index) {
            this.carouselIndex = index;
            this.currentData = this.imgList[index];
        },

        // 初始化viewer组件
        initViewer (resolve) {
            if (this.srcList.length > 0) {
                const barOptions = { show: true, size: 'default' };
                this.viewer = new Viewer(document.getElementById('goodsViewers'), {
                    title: false,
                    inline: true,
                    navbar: true,
                    focus: false, // 关闭页面自动定位到viewer
                    backdrop: true, // 透明背景色
                    zoomOnWheel: true, // 滚动缩放
                    toolbar: {
                        zoomIn: barOptions,
                        zoomOut: barOptions,
                        oneToOne: barOptions,
                        reset: barOptions,
                        prev: {
                            show: true,
                            size: 'default',
                            click: () => {
                                if (this.carouselIndex === 0) {
                                    return this.$message.warning('当前图片是第一张');
                                } else {
                                    this.carouselIndex -= 1;
                                    this.viewer.prev(true);
                                }
                            }
                        },
                        play: barOptions,
                        next: {
                            show: true,
                            size: 'default',
                            click: () => {
                                if (this.carouselIndex === this.imgList.length - 1) {
                                    return this.$message.warning('当前图片是最后一张');
                                } else {
                                    this.carouselIndex += 1;
                                    this.viewer.next(true);
                                }
                            }
                        },
                        rotateLeft: barOptions,
                        rotateRight: barOptions,
                        flipHorizontal: barOptions,
                        flipVertical: barOptions
                    },
                    viewed: data => { // 图片加载完成时回调
                        this.updateInfo(data.detail.index);
                        resolve();
                    }
                });
            }
        },
        show () {
            this.viewer.element && this.viewer.destroy(); // 删除viewer上一次的实例
            const copyAttachmentList = _.cloneDeep(this.attachmentList);
            this.imgList = filterObjectsByProperty(copyAttachmentList, 'path');
            this.srcList = this.imgList.map(v => v.path);
            this.$nextTick(() => {
                new Promise(resolve => {
                    this.initViewer(resolve);
                }).then(() => { });
            });
        }
    }
};
</script>
<style lang="less">
.receiptUpload {
    text-align: center;
    height: 60%;
    .fileName-text {
        max-width: 310px;
        margin-bottom: 5px;
        overflow: hidden; /* 隐藏溢出内容 */
        white-space: nowrap; /* 强制内容在一行显示 */
        text-overflow: ellipsis; /* 添加省略号 */
    }
    .uploader-sign {
        text-align: center;
        .pictures {
            border-radius: 4px;
            border: 1px dashed #00bcbf;
            color: #00bcbf;
            width: 20px;
            line-height: 20px;
            text-align: center;
        }
        .upload-demo {
            display: inline-block;
        }
        .el-button {
            margin-left: 30px;
        }
        .el-icon-delete,
        .el-icon-download,
        .el-icon-loading {
            cursor: pointer;
            color: #00bcbf;
            font-size: 22px;
            vertical-align: middle;
        }
        .input-upload-paste {
            height: 20px;
            width: 280px;
            margin-top: 5px;
            border-radius: 3%;
            border: 1px solid #00bcbf;
        }
        .input-upload-paste::placeholder {
            text-align: center;
        }
        .el-upload-dragger {
            position: relative !important;
            top: 10px !important;
        }
    }
    .noUpload-sign {
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 75%;
        .input-upload-paste {
            height: 20px;
            width: 280px;
            margin-top: 15px;
            border-radius: 3%;
            border: 1px solid #00bcbf;
        }
        .input-upload-paste::placeholder {
            text-align: center;
        }
        .drag-tip {
            display: flex;
            line-height: 30px;
            justify-content: center;
            margin-top: 10px;
            text-align: center;
            font-size: 14px !important;
        }
    }
    .notImg {
        border-radius: 4px;
        border: 2px dashed #00bcbf;
        color: #00bcbf;
        font-size: 40px;
        width: 130px;
        line-height: 130px;
        text-align: center;
    }
    .pictures {
        border-radius: 4px;
        border: 1px dashed #00bcbf;
        color: #00bcbf;
        width: 20px;
        line-height: 20px;
        text-align: center;
    }
    #goodsViewers {
        display: none;
    }
    // .viewer-backdrop {
    //     background-color: transparent;
    // }
    // .viewer-footer {
    //     .viewer-navbar {
    //         display: none;
    //     }
    // }
}
.drawer-modal {
    z-index: 2016;
    position: fixed;
    top: 40%;
    right: 0;
    color: #fff;
    border: 1px solid rgb(0, 188, 191);
    background-color: rgb(0, 188, 191);
}
.good-list-modal {
    z-index: 2016;
    position: fixed;
    top: 50px;
    bottom: 0;
    right: 0;
    width: 50%;
    text-align: left;
    border-radius: 20px 0 0 20px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
    transition: right 1s ease;
    background: #fff;
    .el-icon-close {
        cursor: pointer;
        font-size: 24px;
        margin: 10px 0 0 5px;
    }
    .good-main {
        margin-top: 20px;
    }
}
.sidebar-enter-active,
.sidebar-leave-active {
    transition: all 0.5s;
}

.sidebar-enter,
.sidebar-leave-to {
    transform: translateX(100%);
}
</style>
